import { ActionCreator } from 'redux';
import { AccessToken, AccessTokenPayload, AccessTokenType } from '@dev/ee-api/ee-api-models';
import {
    LoadAccessTokensAction,
    LoadAccessTokensErrorAction,
    LoadAccessTokensSuccessAction,
    AddAccessTokenAction,
    AddAccessTokenErrorAction,
    AddAccessTokenSuccessAction,
    DeleteAccessTokenAction,
    DeleteAccessTokenSuccessAction,
    DeleteAccessTokenErrorAction,
    UpdateAccessTokenAction,
    UpdateAccessTokenSuccessAction,
    UpdateAccessTokenErrorAction,
    ShowAccessTokenCredentialsAction,
    HideAccessTokenCredentialsAction,
    AccessTokenDialogTypeEnum,
    ChangeAccessTokenAction,
    ChangeAccessTokenSuccessAction,
    ChangeAccessTokenErrorAction,
} from './types';

export const AccessTokensLoadingStart: ActionCreator<LoadAccessTokensAction> = (): LoadAccessTokensAction => ({
    type: '@@security/FETCH_ACCESS_TOKENS',
    payload: {
        accessTokensLoading: true,
    },
});
export const AccessTokensLoadingError: ActionCreator<LoadAccessTokensErrorAction> = (): LoadAccessTokensErrorAction => ({
    type: '@@security/FETCH_ACCESS_TOKENS_ERROR',
    payload: {
        accessTokensLoading: false,
    },
});
export const AccessTokensLoadingSuccess: ActionCreator<LoadAccessTokensSuccessAction> = (
    accessTokens: AccessToken[]
): LoadAccessTokensSuccessAction => ({
    type: '@@security/FETCH_ACCESS_TOKENS_SUCCESS',
    payload: {
        accessTokensLoading: false,
        accessTokens,
    },
});
export const AccessTokenAdd: ActionCreator<AddAccessTokenAction> = (accessToken: AccessTokenPayload): AddAccessTokenAction => ({
    type: '@@security/ADD_ACCESS_TOKEN',
    payload: {
        accessToken,
        accessTokensLoading: true,
    },
});
export const AccessTokenAddError: ActionCreator<AddAccessTokenErrorAction> = (): AddAccessTokenErrorAction => ({
    type: '@@security/ADD_ACCESS_TOKEN_ERROR',
    payload: {
        accessTokensLoading: false,
    },
});
export const AccessTokenAddSuccess: ActionCreator<AddAccessTokenSuccessAction> = (
    accessTokens: AccessToken[]
): AddAccessTokenSuccessAction => ({
    type: '@@security/ADD_ACCESS_TOKEN_SUCCESS',
    payload: {
        accessTokens,
        accessTokensLoading: false,
    },
});
export const AccessTokenDelete: ActionCreator<DeleteAccessTokenAction> = (
    name: string,
    type: AccessTokenType
): DeleteAccessTokenAction => ({
    type: '@@security/DELETE_ACCESS_TOKEN',
    payload: {
        name,
        type,
    },
});
export const AccessTokenDeleteSuccess: ActionCreator<DeleteAccessTokenSuccessAction> = (): DeleteAccessTokenSuccessAction => ({
    type: '@@security/DELETE_ACCESS_TOKEN_SUCCESS',
});
export const AccessTokenDeleteError: ActionCreator<DeleteAccessTokenErrorAction> = (): DeleteAccessTokenErrorAction => ({
    type: '@@security/DELETE_ACCESS_TOKEN_ERROR',
});
export const AccessTokenUpdate: ActionCreator<UpdateAccessTokenAction> = (
    name: string,
    accessToken: AccessTokenPayload
): UpdateAccessTokenAction => ({
    type: '@@security/UPDATE_ACCESS_TOKEN',
    payload: {
        name,
        accessToken,
    },
});
export const AccessTokenUpdateSuccess: ActionCreator<UpdateAccessTokenSuccessAction> = (accessTokens: AccessToken[]) => ({
    type: '@@security/UPDATE_ACCESS_TOKEN_SUCCESS',
    payload: {
        accessTokens,
    },
});
export const AccessTokenUpdateError: ActionCreator<UpdateAccessTokenErrorAction> = (): UpdateAccessTokenErrorAction => ({
    type: '@@security/UPDATE_ACCESS_TOKEN_ERROR',
});
export const ShowAccessTokenCredentials: ActionCreator<ShowAccessTokenCredentialsAction> = (
    name: string,
    token: string,
    type: AccessTokenDialogTypeEnum,
    tokenType: number
): ShowAccessTokenCredentialsAction => ({
    type: '@@security/SHOW_ACCESS_TOKEN_CREDENTIALS',
    payload: {
        name,
        token,
        type,
        tokenType,
    },
});
export const HideAccessTokenCredentials: ActionCreator<HideAccessTokenCredentialsAction> = (): HideAccessTokenCredentialsAction => ({
    type: '@@security/HIDE_ACCESS_TOKEN_CREDENTIALS',
});

export const ChangeAccessToken: ActionCreator<ChangeAccessTokenAction> = (
    name: string,
    type: AccessTokenType
): ChangeAccessTokenAction => ({
    type: '@@security/CHANGE_ACCESS_TOKEN',
    payload: {
        name,
        type,
    },
});

export const ChangeAccessTokenSuccess: ActionCreator<ChangeAccessTokenSuccessAction> = (): ChangeAccessTokenSuccessAction => ({
    type: '@@security/CHANGE_ACCESS_TOKEN_SUCCESS',
});
export const ChangeAccessTokenError: ActionCreator<ChangeAccessTokenErrorAction> = (): ChangeAccessTokenErrorAction => ({
    type: '@@security/CHANGE_ACCESS_TOKEN_ERROR',
});
